import { Component, OnInit, OnDestroy, Input} from '@angular/core';
import { Router, NavigationStart } from '@angular/router';
import { Observable, EMPTY, Subscription } from "rxjs";
import { filter, tap } from 'rxjs/operators';

//import { IDateFilterParams, ITextFilterParams, AllModules } from "@ag-grid-enterprise/all-modules";
import { IDateFilterParams, GridApi, GridOptions, ColDef } from "ag-grid-community";


import { SystemNotificationService } from '../../../../notifications/system-notifications/services/system-notification.service';
import { GridFormatterService } from "../../../../common/services/grid-formatter.service";
import { dateFilterComparator } from "../../../../common/components/data-table/comparators/data-table.comparators";
import { IconComponent } from "../../../../common/components/data-table/columns/icon/icon.component";
import { UrlComponent } from "../../../../common/components/data-table/columns/url/url.component";
import { ModalInfoComponent } from "../../../../common/components/ag-grid/modal-info.component";
import { Column, ObjectProperties, } from '../../../../common/components/data-table/models/column.interface';
import { ValueFormatter } from '../../../../common/components/data-table/formatters/data-table.formatters';
import { SystemNotification } from '../../../../notifications/system-notifications/models/system-notification.model';
import { componentFrameworks } from '../../../../common/components/data-table/data-table.component';
//import { GridOptions, ColDef } from '@ag-grid-enterprise/all-modules';
import { dateComparator } from '../../../../common/components/data-table/comparators/data-table.comparators';
import { AuthService } from "../../../../services/auth.service";

@Component({
    selector: 'notifications-widget',
    templateUrl: './notifications-widget.component.html',
    styleUrls: ['./notifications-widget.component.scss'],
    providers: [SystemNotificationService],
    standalone: false
})
export class NotificationsWidgetComponent implements OnInit, OnDestroy {
    @Input() widgetTitle: string;


    icons = new Map(
        [
            ["Permit", 'icon-checkbox'],
            ["WorkOrder", 'icon-approved-permit'],
            ["FinancialAssurance", 'icon-checkbox'],
            ["General", 'icon-checkbox'],
            ["Letter", 'icon-mail'],
            ["Scanning", 'icon-upload'],
            ["Reminder", 'icon-alert'],
            ["Expedited", 'icon-alert'],
            ["eDiscovery", 'icon-view'],
            ["ComplianceReport", "icon-new-report"],
            ["Issue", 'icon-alert']
        ]);   

    columnDefs: ColDef[] = [
        {
            headerClass: "wrapped",
            comparator: dateComparator,                     
            field: "timestamp",
            filter: "agDateColumnFilter",
            filterParams: { browserDatePicker: true, comparator: dateFilterComparator, includeTime: false, buttons: ['reset'] } as IDateFilterParams,
            headerName: "Date",
            headerTooltip: "Date",   
            maxWidth: 150,
            minWidth: 135,
            sort: "desc",
            sortingOrder: ["asc", null, "desc"],
            tooltipValueGetter: this.formatterService.formatDate("timestamp"),
            valueGetter: this.formatterService.formatDate("timestamp")
        } as ColDef,
        {
            headerClass: "wrapped",
            cellRenderer: IconComponent,
            cellRendererParams: { icons: this.icons },
            field: "type",
            headerName: "Type",
            headerTooltip: "Type",
            minWidth: 60,
            maxWidth: 90,
            sortingOrder: ["asc", null, "desc"]
        } as ColDef, 
        {
            cellRendererSelector: (params) => {                
                if (params.data.redirectUrl) {
                    if (params.data.flowIsOnBehalf) {
                        if (this._authService.User.isInternal) {
                            return {
                                component: UrlComponent,
                                params: { values: { url: (data) => { return data.redirectUrl; }, text: (data) => { return data.description; } } }
                            };
                        } else {
                            return {
								component: ModalInfoComponent,
                                params: {
                                    text: (data: any) => {
                                        if (data.description.endsWith('.')) {
                                            return `${data.description}  Paper Applications must be handled by ODNR personnel.`;
                                        }
                                        return `${data.description}.  Paper Applications must be handled by ODNR personnel.`;
                                    },
                                    modalText: (data: any) => {
                                        if (data.description.endsWith('.')) {
                                            return `${data.description} <br /> <span class='bold'>Paper Applications must be handled by ODNR personnel.</span>`
                                        }
                                        return `${data.description}. <br /> <span class='bold'>Paper Applications must be handled by ODNR personnel.</span>`
                                    }
                                }
                            };
                        }
                    } else {
                        return {
							component: UrlComponent,
                            params: {
                                values: { url: (data: any) => { return data.redirectUrl; }, text: (data: any) => { return data.description; } }
                            }
                        }
                    }
                    
                }
                return {
                    component: ModalInfoComponent, params: {
                        text: (data: any) => { return data.description; } 
                    }
                };
            },
            field: "description",
            filter: "agTextColumnFilter",
            headerClass: "wrapped",
            headerName: "Description",
            headerTooltip: "Description",
            tooltipField: "description"
        } as ColDef
    ] as ColDef[];

    dataset: Observable<SystemNotification[]>;
	gridApi?: GridApi;
    gridOptions: GridOptions = {
        columnDefs: this.columnDefs,
        defaultColDef: { filter: true, floatingFilter: false, resizable: true, sortable: true, sortingOrder: ['asc', null, 'desc' ] } as ColDef,
        enableBrowserTooltips: false,
        tooltipTrigger: 'focus',
		onGridReady: (params) => {
			this.gridApi = params.api;
			this.gridApi.sizeColumnsToFit();
		},
        pagination: true,
        paginationAutoPageSize: true,
        headerHeight: 50     
    };


    routerSubscription = new Subscription();

    constructor(
        private _authService: AuthService,
        public _notificationService: SystemNotificationService,
        private formatterService: GridFormatterService,
        private router: Router
    ) {
		this.dataset = this._notificationService.getNotifications(null);
        this.formatterService.applyFilterKeyboardHintTooltips(this.columnDefs);
    }

    ngOnInit() {
        this.routerSubscription.add(this.router.events.pipe(filter(e => e instanceof NavigationStart)).subscribe((routerEvent: NavigationStart) => {
            this.dataset = EMPTY;
        }));
    }   

    ngOnDestroy() {
        this.routerSubscription.unsubscribe();
    }
}
